import { useContext } from "react";

import isEmptyObject from "Utilities/isEmptyObject";

import { BoardContext } from "./BoardContext";

export function useSavedBoardFilter() {
  const [state] = useContext(BoardContext);

  function applySavedBoardFilter() {
    if (!state.savedBoardFilter || isEmptyObject(state.savedBoardFilter))
      return;

    window.fnReactBus.applySavedBoardFilter(state?.savedBoardFilter);
  }

  return { applySavedBoardFilter };
}
